import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet";
import "./HomePage.css";
import MemorialPage from "../User/MemorialPage/MemorialPage";
import image8 from "../../assets/8.webp";
import axios from "axios";
import { Link } from "react-router-dom";
import CountUp from "react-countup"; // استيراد مكتبة CountUp

export default function HomePage() {
  const [recentBurials, setRecentBurials] = useState([]);
  const [articles, setArticles] = useState([]);
  const [error, setError] = useState("");
  const [totalDeaths, setTotalDeaths] = useState(0);
  const [availableGraves, setAvailableGraves] = useState(0);
  const [unavailableGraves, setUnavailableGraves] = useState(0);
  const [maleDeaths, setMaleDeaths] = useState(0);
  const [femaleDeaths, setFemaleDeaths] = useState(0);
  const [showStats, setShowStats] = useState(false); // For triggering stats counting

  const statsRef = useRef(null); // Reference for stats section

  // Function to start counting when stats section is visible
  const startCounting = () => {
    setShowStats(true);
  };

  useEffect(() => {
    // ✅ استدعاء API لتحديث حالة المقابر يدوياً عند فتح الصفحة
    const updateGraveStatuses = async () => {
      try {
        await axios.get(
          "https://cemetery-management.vercel.app/api/graves/update-status"
        );
        console.log("✅ تم تحديث حالة المقابر بنجاح من خلال API.");
      } catch (error) {
        console.error("❌ حدث خطأ أثناء تحديث حالة المقابر:", error);
      }
    };

    const fetchRecentBurials = async () => {
      try {
        const response = await axios.get(
          "https://cemetery-management.vercel.app/api/graves/recentBurials"
        );
        setRecentBurials(response.data);
      } catch (error) {
        console.error("Error fetching recent burials:", error);
      }
    };

    const fetchArticles = async () => {
      try {
        const response = await axios.get(
          "https://cemetery-management.vercel.app/api/articles"
        );
        setArticles(response.data);
      } catch (err) {
        setError("حدث خطأ أثناء جلب المقالات.");
      }
    };

    const fetchStatistics = async () => {
      try {
        const totalDeathsResponse = await axios.get(
          "https://cemetery-management.vercel.app/api/graves/totalDeaths"
        );
        setTotalDeaths(totalDeathsResponse.data.totalDeaths);

        const availableGravesResponse = await axios.get(
          "https://cemetery-management.vercel.app/api/graves/available-count"
        );
        setAvailableGraves(
          availableGravesResponse.data.availableGravesCount
        );

        const unavailableGravesResponse = await axios.get(
          "https://cemetery-management.vercel.app/api/graves/unavailable-count"
        );
        setUnavailableGraves(
          unavailableGravesResponse.data.unavailableGravesCount
        );

        const maleDeathsResponse = await axios.get(
          "https://cemetery-management.vercel.app/api/graves/maleDeaths"
        );
        setMaleDeaths(maleDeathsResponse.data.maleDeaths);

        const femaleDeathsResponse = await axios.get(
          "https://cemetery-management.vercel.app/api/graves/femaleDeaths"
        );
        setFemaleDeaths(femaleDeathsResponse.data.femaleDeaths);
      } catch (error) {
        console.error("Error fetching statistics:", error);
      }
    };

    // 🔹 استدعاء جميع الدوال بالترتيب
    updateGraveStatuses().then(() => {
      fetchRecentBurials();
      fetchArticles();
      fetchStatistics();
    });

    // Create an Intersection Observer to start counting when stats section is visible
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          startCounting();
        }
      },
      { threshold: 0.5 }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => observer.disconnect(); // Cleanup observer when component unmounts
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="UTF-8" />
        <meta
          name="description"
          content="هذا الموقع خاص بمدافن أهالي الشوبك الغربي. يتم العمل على تسجيل وتنظيم حالات الوفيات الخاصة بأهالي القرية"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>مقابر الشوبك الغربي</title>
        <link rel="icon" href="/images/Home.svg" />
      </Helmet>
      <main className="landing">
        <div className="overlay"></div>
        <div className="text-box">
          <div className="content">
            <h1>
              مرحباً بكم فى
              <br />
              موقع مقابر الشوبك الغربي
            </h1>
            <p>
              أهلاً بكم معشر الأحياء .. كنا في يوم من الأيام بينكم، نتسامر أطراف
              الحديث، نضحك ونبكي، نغدو ونروح، نأكل ونشرب، لكن شاء الله أن نسبقكم
              إلى دار الاخرة، لاتحزنو كثيرا، فهذه سنة الله في خلقه،نحن السابقون و
              انتم اللاحقون ننتظركم هنا.
              <br />
              وحتى يختم الله لكم على خير، نسألكم الدعاء لنا، والتصدق باسمنا، قد
              يبدو الأمر يسيراً عليكم، لكن للأمر أثر جليل هنا، فلا تغفلوا عنا
              واجعلونا دائما في ذكراكم.
              <br />
              شكراً على هذه الزيارة الطيبة، <br />
              <span>نسألكم الدعاء لنا ولجميع أموات المسلمين.</span>
            </p>
          </div>
        </div>
      </main>

      {/* Services Section */}
      <div className="services">
        <div className="container">
          <div className="main-heading">
            <h2>الخدمات</h2>
            <p>
              يعمل الموقع على تنظيم عملية الدفن، ومعرفة حالة كل عين داخل المقابر
              (فارغة - ممتلئة). كما يسعى إلى حفظ بيانات المتوفيين والرجوع لها في
              أي وقت.
            </p>
          </div>
          <div className="sections">
            <Link to="/man">
              <section className="box">
                <h3>مدافن الرجال</h3>
                <p>
                  يحتوي قسم مدافن الرجال على أسماء جميع الرجال الذين توفاهم الله
                  من قرية الشوبك الغربي.
                </p>
              </section>
            </Link>
            <Link to="/woman">
              <section className="box">
                <h3>مدافن النساء</h3>
                <p>
                  يحتوي قسم مدافن النساء على أسماء جميع النساء الذين توفاهم الله
                  من قرية الشوبك الغربي.
                </p>
              </section>
            </Link>
            <Link to="/bones">
              <section className="box">
                <h3>مدافن العظام</h3>
                <p>
                  يحتوي قسم مدافن العظام على أسماء جميع الرجال والنساء الذين
                  توفاهم الله وتم نقل رفاتهم الى مدافن العظام.
                </p>
              </section>
            </Link>
          </div>
        </div>
      </div>

      {/* Burial Section */}
      <div className="home-container">
        <div className="main-heading">
          <h2>حداد</h2>
        </div>

        <div className="burials-cards">
          {recentBurials.map((grave) =>
            grave.buriedPersons.map((person) => (
              <div key={person._id} className="burial-card">
                <div className="image"><img src={image8} alt="Avatar" className="avatar" /></div>
                <div className="person-info">
                  <h3> {person.name}</h3>
                  <p>
                    تاريخ الدفن:{" "}
                    {new Date(person.burialDate).toLocaleDateString()}
                  </p>
                </div>
              </div>
              
            ))
          )}
        </div>

        <div className="condolence-section">
          <p className="condolence-text">
            خالص العزاء والمواساه لأهل المتوفي <br />
            نسأل الله تعالى أن يتغمده بواسع رحمته وأن يلهم أهله وذويه الصبر
            والسلوان
          </p>
        </div>
      </div>

      {/* Stats Section */}
      <div className="all-nambers" ref={statsRef}>
        <div className="overlay"></div>
        <div className="container">
          <div className="cotent">
            <div className="box">
              <span>
                {showStats ? (
                  <CountUp end={availableGraves} duration={2.5} />
                ) : (
                  0
                )}
              </span>
              <p>العيون المتاحة</p>
            </div>
            <div className="box">
              <span>
                {showStats ? (
                  <CountUp end={unavailableGraves} duration={2.5} />
                ) : (
                  0
                )}
              </span>
              <p>العيون غير المتاحة</p>
            </div>
            <div className="box">
              <span>
                {showStats ? (
                  <CountUp end={totalDeaths} duration={2.5} />
                ) : (
                  0
                )}
              </span>
              <p translate="no">إجمالي الوفيات</p>
            </div>
            <div className="box dis-none">
              <span>
                {showStats ? (
                  <CountUp end={maleDeaths} duration={2.5} />
                ) : (
                  0
                )}
              </span>
              <p>وفيات الرجال</p>
            </div>
            <div className="box dis-none">
              <span>
                {showStats ? (
                  <CountUp end={femaleDeaths} duration={2.5} />
                ) : (
                  0
                )}
              </span>
              <p>وفيات النساء</p>
            </div>
          </div>
        </div>
      </div>

      {/* Articles Section */}
      <article className="articles-container">
        <div className="container">
          <div className="main-heading">
            <h2>مقالات</h2>
            <p>
              مجموعة من المقالات المبسطة تحتوي على بعض المعلومات <br /> بهدف
              التوعية ونشر الثقافة الصحيحة بهذا الشأن.
            </p>
          </div>
          <div className="articles">
            {error && <p className="error">{error}</p>}
            {articles.length === 0 ? (
              <p>لا توجد مقالات حتى الآن.</p>
            ) : (
              articles.map((article) => (
                <a href={`/ArticleDetail/${article._id}`} key={article._id}>
                  <div className="article-card">
                    <h2>{article.title}</h2>
                  </div>
                </a>
              ))
            )}
          </div>
        </div>
      </article>

      {/* MemorialPage Section */}
      <MemorialPage />

      <div className="about">
        <div className="container">
          <div className="main-heading">
            <h2 className="after">عنا</h2>
            <bdi>
              تم إنشاء هذا الموقع صدقة جارية على روح المرحوم{" "}
              <a href="https://www.facebook.com/profile.php?id=100011924929152">
                محمد رضا السنوطي{" "}
              </a>
              .. نسألكم الدعاء له ولجميع أموات المسلمين بالرحمة والمغفرة.
            </bdi>
          </div>
        </div>
      </div>
    </>
  );
}
